import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const friendLinks = [
  { label: '国家政务服务平台', url: 'https://91bl1.asia' },
  { label: '中国互联网协会', url: 'https://www.isc.org.cn' },
  { label: '世界知识门户', url: 'https://www.wikipedia.org' },
  { label: '开放数据联盟', url: 'https://www.example.org' },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-secondary-900 text-secondary-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-compass-3-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">网址大全</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-200">
              权威综合资源网站目录平台，汇集海量优质网站资源，助你快速找到所需入口，提升浏览效率。
            </p>
            <div className="mt-4 flex items-center gap-3 text-lg text-secondary-200">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-800">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-800">
                <i className="ri-mail-line"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-800">
                <i className="ri-rss-line"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-background-50">
              <Link to="/about" className="transition-colors hover:text-accent-300">
                网站导航
              </Link>
            </h4>
            <ul className="mt-4 space-y-2 text-sm text-secondary-200">
              <li>
                <Link to="/" className="transition-colors hover:text-background-50">首页</Link>
              </li>
              <li>
                <Link to="/about" className="transition-colors hover:text-background-50">关于我们</Link>
              </li>
              <li>
                <Link to="/contact" className="transition-colors hover:text-background-50">联系我们</Link>
              </li>
              <li>
                <Link to="/contact" className="transition-colors hover:text-background-50">网站收录申请</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-background-50">
              <Link to="/category/portal" className="transition-colors hover:text-accent-300">
                热门分类
              </Link>
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2 text-sm text-secondary-200">
              {categories.slice(0, 6).map((category) => (
                <li key={category.id}>
                  <Link to={`/category/${category.id}`} className="transition-colors hover:text-background-50">
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-background-50">友情链接</h4>
            <ul className="mt-4 space-y-2 text-sm text-secondary-200">
              {friendLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="flex w-full flex-col gap-3 px-4 py-5 text-xs text-secondary-300 sm:flex-row sm:items-center sm:justify-between md:px-8">
          <p>© 2026 网址大全 · 权威综合资源网站目录平台 · 京ICP备00000000号</p>
          <div className="flex flex-wrap items-center gap-4">
            <Link to="/about" className="transition-colors hover:text-background-50">隐私政策</Link>
            <Link to="/about" className="transition-colors hover:text-background-50">服务条款</Link>
            <Link to="/contact" className="transition-colors hover:text-background-50">收录说明</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}